import { Amplify } from 'aws-amplify';
import { sessionStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { getAppConfig } from './appConfig';

const appConfig = getAppConfig();

// Configure Amplify (v6)
const configureAmplify = (): void => {
  const config = {
    Auth: {
      Cognito: {
        userPoolId: appConfig.USER_POOL_ID,
        userPoolClientId: appConfig.USER_POOL_CLIENT_ID, // v6 key
      },
    },
  };

  Amplify.configure(config);
  cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);
};

export default configureAmplify;
